export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.8.21-1614.17",
  commitId: "21c50a12ebc61f7aa4e0e01b4fe5d65625a4ef4f",
  commitTime: "2026-08-21T16:14:17.000Z",
});
